import React from 'react';
import './App.css';
import produce from "immer";

import ControlPanel from "./components/ControlPanel"
import Exercise from "./components/Exercise"

// TODO: Rename this to data.
const workout = {
  exercises: {
    "1": {
      name: "Cross Trainer",
      type: "cardio",
      sets: ["a"]
    },
    "2": {
      name: "Dumbbell Bench Press",
      type: "weights",
      sets: ["b", "c", "d", "e"]
    },
    "3": {
      name: "Dumbbell Row",
      type: "weights",
      sets: ["f", "g", "h", "i"]
    }
  },
  sets: {
    "a": { duration: "", calories: "250" },
    "b": { weight : "11.5", reps: "8" },
    "c": { weight : "20.5", reps: "8" },
    "d": { weight : "20.5", reps: "8" },
    "e": { weight : "20.5", reps: "8" },
    "f": { weight : "11.5", reps: "8" },
    "g": { weight : "20.5", reps: "8" },
    "h": { weight : "20.5", reps: "8" },
    "i": { weight : "20.5", reps: "8" },
  },
  workouts: {
    "A": {
      date: new Date(2019, 10, 30),
      exercises: ["2", "3"]
    },
    "B": {
      date: new Date(2019, 11, 2),
      exercises: ["1"]
    },
  },
  all_workouts: ["B", "A"]
}

function emptyData() {
  return {
    exercises: {},
    sets: {},
    workouts: {},
    all_workouts: []
  }
}

function genId() {
  return Math.random().toString(36).substring(2)
}

function addExercise(oldWorkout, name, type) {
  return produce(oldWorkout, draftState => {
    const id = genId();

    const currentWorkout = draftState.all_workouts[0];
    draftState.workouts[currentWorkout].exercises.push(id);

    draftState.exercises[id] = {
      id: genId(),
      name: name,
      type: type,
      sets: []
    };
  });
}

function addSet(oldWorkout, exerciseId) {
  return produce(oldWorkout, draftState => {
    const type = draftState.exercises[exerciseId].type;
    const id = genId();

    draftState.exercises[exerciseId].sets.push(id);

    let set = {}
    if (type === "weights") {
      set = {
        id: genId(), weight: "", reps: ""
      }
    } else {
      set = {
        id: genId(), duration: "", calories: ""
      }
    }

    draftState.sets[id] = set;
  });
}

function addWorkout(oldWorkout, date) {
  return produce(oldWorkout, draftState => {
    const id = genId();
    draftState.all_workouts.unshift(id);

    draftState.workouts[id] = {
      date: date,
      exercises: []
    }
  });
}

function updateSet(oldWorkout, setId, key, value) {
  return produce(oldWorkout, draftState => {
    draftState.sets[setId][key] = value
  })
}

const App = () => {
  const stringData = localStorage.getItem('workout_data');
  const loadedData = (stringData === undefined ? emptyData() : JSON.parse(stringData))

  const [data, setData] = React.useState(loadedData);

  const handleAddSet = (exerciseId) => {
    setData(addSet(data, exerciseId))
  }
  const handleUpdateSet = (setId, key, value) => {
    setData(updateSet(data, setId, key, value))
  }
  const handleAddExercise = (type, name) => {
    setData(addExercise(data, name, type))
  }
  const handleAddWorkout = () => {
    setData(addWorkout(data, new Date().toDateString()))
  }

  React.useEffect(() => {
    localStorage.setItem("workout_data", JSON.stringify(data))
  }, [data])

  return (
    <div className="App measure">
      {data["all_workouts"].map(workoutId =>
        <div key={workoutId}>
          <h1 className="ma3">
            {data.workouts[workoutId].date}
          </h1>
          {data.workouts[workoutId].exercises.map(exerciseId =>
            <Exercise
              key={exerciseId}
              exercise={data.exercises[exerciseId]}
              sets={data.sets}
              addSet={() => {handleAddSet(exerciseId)}}
              updateSet={handleUpdateSet}/>
          )}
        </div>
      )}

      <ControlPanel
        handleAddExercise={handleAddExercise}
        handleAddDate={handleAddWorkout} />
    </div>
  );
}

export default App;
